import { FilterFields, parseFilterParams, TableHeadKeys } from '@web/helpers/filter';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router';

export function deletePageParamIfSearchUpdated(updates: object, params: URLSearchParams) {
  // Check if there are any props other than page and pageSize
  // If there, are, delete the page param to reset the page to 1
  if (Object.keys(updates).some((key) => key !== 'page' && key !== 'pageSize')) {
    params.delete('page');
  }
}

export const useRoutingFilterParams = <K extends string>(headers: TableHeadKeys<K>[]) => {
  const [params, setSearchParams] = useSearchParams();

  const handleSetParams = useCallback(
    (newState: FilterFields<K>) => {
      const newParams = new URLSearchParams();
      // Populate the URLSearchParams with the old values first
      for (const [key, value] of params) {
        // Don't include the page number since it will be reset
        if (key === 'page') continue;
        newParams.set(key, value);
      }

      for (const headerName of headers) {
        if (newState[headerName]) {
          newParams.set(headerName, newState[headerName]);
        } else {
          newParams.delete(headerName);
        }
      }
      deletePageParamIfSearchUpdated(newState, newParams);
      setSearchParams(newParams, { replace: true });
    },
    [params, setSearchParams, headers],
  );

  const paramsData = useMemo(() => parseFilterParams(params, headers), [params, headers]);

  return { paramsData, handleSetParams };
};
